export enum HotelEventImageType {
  SEATING_ARRANGEMENT = 'SeatingArrangement',
  GENERAL = 'General',
}
